import { fromJS } from 'immutable';
import { dispatch } from 'nike-re-framejs';

import { loadSettings } from './web-notification-service-ctx';
import { loadSubscriptions } from '@/notifications/handlers';

export function browserInfo() {
    let browserSupported = false;
    let browserGranted = false;
    let browserDenied = false;
    // browser capabilities
    if (window.Notification && Notification.requestPermission) {
        browserSupported = true;
        browserGranted = Notification.permission === 'granted';
        browserDenied = Notification.permission === 'denied';
    }
    return { browserSupported, browserGranted, browserDenied };
}

export function notificationOnDeviceEnabled() {
    const info = browserInfo();
    return info.browserSupported && info.browserGranted;
}

export function initNotificationSettings(db) {
    if (db.get('loggedIn')) {
        setTimeout(() => dispatch(loadSubscriptions));
    }
    return db.setIn(['notifications', 'settings'], fromJS(loadSettings()));
}
